import Swal from "sweetalert2";
<template>
    <div class="card card-custom gutter-b">
        <div class="card-header d-flex justify-content-between">
            <div class="card-title">
                <h3 class="card-label">Danh sách văn phòng</h3>
            </div>
        </div>
        <div class="card-body">
            <!--begin::Example-->
            <div class="example mb-10">
                <div class="row">
                    <div class="form-group col-md-3">
                        <div class="input-group">
                            <div class="input-group-prepend">
																<span class="input-group-text line-height-0 py-0">
																	<span class="svg-icon">
																		<!--begin::Svg Icon | path:/metronic/theme/html/demo1/dist/assets/media/svg/icons/General/Search.svg-->
																		<svg xmlns="http://www.w3.org/2000/svg"
                                                                             xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                             width="24px" height="24px"
                                                                             viewBox="0 0 24 24" version="1.1">
																			<g stroke="none" stroke-width="1"
                                                                               fill="none" fill-rule="evenodd">
																				<rect x="0" y="0" width="24"
                                                                                      height="24"></rect>
																				<path d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                                                                                      fill="#000000" fill-rule="nonzero"
                                                                                      opacity="0.3"></path>
																				<path d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                                                                                      fill="#000000"
                                                                                      fill-rule="nonzero"></path>
																			</g>
																		</svg>
                                                                        <!--end::Svg Icon-->
																	</span>
																</span>
                            </div>
                            <input type="text" class="form-control" placeholder="Tên văn phòng" v-model="query.keyword_alias"
                                   @input="search"
                                   aria-describedby="basic-addon2">
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group">
                            <multiselect v-model="cacheStatus"
                                         :options="status"
                                         placeholder="Trạng thái"
                                         label="name"
                                         track-by="name"
                                         @input="handleQueryStatus($event)"
                            ></multiselect>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <el-select class="w-100" v-model="cacheWorkplace" placeholder="Địa điểm làm việc"
                             @change="handleQueryWorkplace($event)" clearable filterable>
                                <el-option
                                    v-for="item in workplaces"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <!--end::Form-->
                    </div>
                </div>
                <div class="example-preview table-responsive">
                    <table class="table table-vertical-center">
                        <thead>
                        <tr>
                            <th scope="col" class="min-w-100px">Tên văn phòng</th>
                            <th scope="col" class="min-w-100px">Trung tâm</th>
                            <th scope="col" class="min-w-100px">Tên chi nhánh</th>
                            <th scope="col" class="min-w-100px">Địa điểm làm việc</th>
                            <th scope="col" class="min-w-100px">Thời gian hoạt động</th>
                            <th scope="col" class="min-w-100px">Trạng thái</th>
                            <th scope="col" class="min-w-100px">Hành động</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in branches" :key="index">
                            <td>{{ item.name_alias }}</td>
                            <td>{{ item.center != null ? item.center.name : '' }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.workplace_branch ? item.workplace_branch.name : item.name }}</td>
                            <td>{{item.open_date}}</td>
                            <td>
                                <el-switch
                                    @change="handleUpdateStatusUserByBot(item)"
                                    v-model="item.statusBool"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949">
                                </el-switch>

                            </td>
                            <td>
                                <button @click="getBranch(item)" class="btn btn-sm btn-icon mr-2 btn-outline-info">
                                    <i class="fas fa-pen-nib"></i>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="edu-paginate mx-auto text-center">
            <paginate
                v-model="page"
                :page-count="last_page"
                :page-range="3"
                :margin-pages="1"
                :click-handler="clickCallback"
                :prev-text="'Trước'"
                :next-text="'Sau'"
                :container-class="'pagination b-pagination'"
                :pageLinkClass="'page-link'"
                :next-link-class="'next-link-item'"
                :prev-link-class="'prev-link-item'"
                :prev-class="'page-link'"
                :next-class="'page-link'"
                :page-class="'page-item'"
            >
            </paginate>
        </div>
        <el-dialog title="Sửa văn phòng" :visible.sync="dialogEdit">
            <div>
                <ValidationObserver v-slot="{ handleSubmit }" ref="form">
                    <form class="form" id="branch_create" @submit.prevent="handleSubmit(onSubmitEdit)">
                        <div class="col-md-12 d-flex">
                            <div class="col-md-6">
                                <label for="">Tên chi nhánh</label>
                                <input type="text" ref="name" name="name" class="form-control" v-model="branch.name"
                                       placeholder="Tên chi nhánh"  disabled>
                            </div>
                            <div class="col-md-6">
                                <label for="">Tên văn phòng</label>
                                <ValidationProvider vid="name_alias" name="Tên văn phòng" rules="" v-slot="{ errors,classes }">
                                    <input type="text" ref="name_alias" name="name_alias" class="form-control" v-model="branch.name_alias"
                                           placeholder="Tên văn phòng" :class="classes">
                                    <div class="fv-plugins-message-container">
                                        <div data-field="Tên văn phòng" data-validator="notEmpty" class="fv-help-block">{{
                                                errors[0]
                                            }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="col-md-12 d-flex">
                            <div class="col-md-6">
                                <label for="">Khu vực</label>
                                <ValidationProvider vid="area" name="Khu vực" rules="" v-slot="{ errors,classes }">
                                    <el-select class="w-100" v-model="branch.area_id" clearable filterable collapse-tags placeholder="Chọn khu vực" >
                                        <el-option
                                            v-for="item in areas"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                    <div class="fv-plugins-message-container">
                                        <div data-field="Khu vực" data-validator="notEmpty" class="fv-help-block">{{
                                                errors[0]
                                            }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-md-6">
                                <label for="">Thời gian hoạt động</label>
                                <ValidationProvider vid="open_date" name="Thời gian hoạt động" rules="" v-slot="{ errors,classes }">
                                    <date-picker v-model="branch.open_date" placeholder="Chọn ngày tháng"  format="DD-MM-YYYY" class="w-100" valueType="YYYY-MM-DD"></date-picker>
                                    <div class="fv-plugins-message-container">
                                        <div data-field="Thời gian hoạt động" data-validator="notEmpty" class="fv-help-block">{{
                                                errors[0]
                                            }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="col-md-12">
                                <label for="">Địa chỉ</label>
                                <ValidationProvider vid="address" name="Địa chỉ" rules="" v-slot="{ errors,classes }">
                                    <input type="text" class="form-control" v-model="branch.address">
                                    <div class="fv-plugins-message-container">
                                        <div data-field="Địa chỉ" data-validator="notEmpty" class="fv-help-block">{{
                                                errors[0]
                                            }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="col-md-12 d-flex">
                            <div class="col-md-6">
                                <label for="">Vĩ độ</label>
                                <ValidationProvider vid="latitude" name="Vĩ độ" rules="" v-slot="{ errors,classes }">
                                    <input type="text"
                                           ref="name_alias"
                                           name="name_alias"
                                           class="form-control"
                                           v-model="branch.latitude"
                                           placeholder="Vĩ độ"
                                           :class="classes"
                                    >
                                    <div class="fv-plugins-message-container">
                                        <div data-field="Vĩ độ" data-validator="notEmpty" class="fv-help-block">{{
                                                errors[0]
                                            }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-md-6">
                                <label for="">Kinh độ</label>
                                <ValidationProvider vid="longitude" name="Kinh độ" rules="" v-slot="{ errors,classes }">
                                    <input type="text"
                                           ref="name_alias"
                                           name="name_alias"
                                           class="form-control"
                                           v-model="branch.longitude"
                                           placeholder="Kinh độ"
                                           :class="classes"
                                    >
                                    <div class="fv-plugins-message-container">
                                        <div data-field="Kinh độ" data-validator="notEmpty" class="fv-help-block">{{
                                                errors[0]
                                            }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="col-md-12 d-flex">
                            <div class="col-md-6">
                                <label for="">Trạng thái</label>
                                <ValidationProvider vid="status" name="Trạng thái" rules="" v-slot="{ errors,classes }">
                                    <el-select v-model="branch.status" size="small" class="w-100"
                                    >
                                        <el-option
                                            v-for="(item,index) in status"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.id"

                                        />
                                    </el-select>
                                    <div class="fv-plugins-message-container">
                                        <div data-field="Trạng thái" data-validator="notEmpty" class="fv-help-block">{{
                                                errors[0]
                                            }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-md-6">
                                <label for="">Địa điểm làm việc</label>
                                <ValidationProvider vid="workplace" name="Địa điểm làm việc" rules="" v-slot="{ errors,classes }">
                                    <el-select v-model="branch.workplace" size="small" class="w-100" clearable
                                               collapse-tags
                                               filterable
                                    >
                                        <el-option
                                            v-for="(item,index) in workplacesInBranch"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.id"

                                        />
                                    </el-select>
                                    <div class="fv-plugins-message-container">
                                        <div data-field="Địa điểm làm việc" data-validator="notEmpty" class="fv-help-block">{{
                                                errors[0]
                                            }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="card-header">
                            <div class="card-title align-items-start flex-column">
                                <button type="submit" class="btn btn-success mr-2">
                                    Cập nhật
                                </button>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    GET_BRANCHES,
    DELETE_BRANCH,
    IMPORT_BRANCH_DATA,
    GET_BRANCH_BY_ID, UPDATE_BRANCH, ACTIVE_BRANCH, GET_WORKPLACE
} from "../../../core/services/store/center/branch.module";
import Swal from "sweetalert2";
import {SET_BREADCRUMB} from "../../../core/services/store/breadcrumbs.module";
import {GET_PROVINCES} from "../../../core/services/store/public/provinces.module";
import {GET_DISTRICTS} from "../../../core/services/store/public/districts.module";
import {GET_CENTERS} from "../../../core/services/store/center/centers.module";
import Multiselect from 'vue-multiselect'
import FileUpload from 'vue-upload-component';
import {GET_LIST_AREAS} from "../../../core/services/store/center/area.module";
const _ = require('lodash');
import DatePicker from 'vue2-datepicker';

export default {
    components: {
        Multiselect,FileUpload,DatePicker
    },
    name: "BranchIndex",
    data() {
        return {
            upload: null,
            files: [],
            isAble : true,
            branches: [],
            centers: [],
            provinces: [],
            districts: [],
            // Paginate
            page: 1,
            last_page: 1,
            query: {
                keyword_alias: '',
                province: '',
                district: '',
                center: '',
                status: '',
                workplace: ''
            },
            districtsByProvince: [],
            areas: [],
            // cache
            cacheProvince: [],
            cacheCenter: [],
            cacheDistrict: [],
            cacheStatus: '',
            cacheWorkplace: '',
            dialogEdit: false,
            branch: {
                name: '',
                name_alias: '',
                longitude: null,
                latitude: null,
                area: '',
                open_date: '',
                address: '',
                status: false,
                area_id: '',
                workplace: ''
            },
            status: [
                {
                    id: '',
                    name: 'Tất cả'
                },
                {
                    id: 0,
                    name: 'Ngưng hoạt động'
                },
                {
                    id: 1,
                    name: 'Hoạt động'
                }
            ],
            workplaces: [],
            workplacesInBranch: []
        }
    },
    async mounted() {
        await this.getCenters()
        await this.getProvinces()
        await this.getDistricts()
        await this.getList()
        this.getAreas();
        await this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Quản lý tên văn phòng"},
            {title: "Danh sách văn phòng"}
        ]);
    },
    methods: {
        getAreas() {
            this.$store.dispatch(GET_LIST_AREAS, {}).then(data => {
                this.areas = data.data;
            });
        },
        onSubmit () {
            let formData = new FormData();
            formData.append('dataImport', this.dataImport);
            this.$store.dispatch(IMPORT_BRANCH_DATA,formData).then( (res) => {
                this.removeFile();
                if (!res.error) {
                    this.$store.dispatch(GET_BRANCHES).then((data) => {
                        this.branches = data.data.data.map(d => ({
                            ...d,
                            statusBool: d.status === 1
                        }))
                        this.$bvToast.toast(res.message, {
                            title: 'Import',
                            variant: 'success',
                            solid: true
                        });
                        this.callApiGetList()
                    })
                }else {
                    this.$bvToast.toast(res.message, {
                        title: 'Import',
                        variant: 'danger',
                        solid: true
                    });
                }
            }).catch(() => {
                this.$bvToast.toast('Có lỗi xảy ra', {
                    title: 'Import',
                    variant: 'danger',
                    solid: true
                });
            });
        },
        async getList() {
            await this.pullParamsUrl()
            await this.setCacheTheLoad()
            await this.callApiGetList()
            await this.selectDistrictByProvince()
            await this.getWorkplaces()
        },
        setCacheTheLoad() {
            if (this.query.center != '') {
                let oldParamCenter = this.centers.filter((value) => {
                    if (parseInt(this.query.center) == value.id) {
                        return value
                    }
                })
                this.cacheCenter = oldParamCenter
            }
            if (this.query.province != '') {
                let oldParamDistrict = this.provinces.filter((value) => {
                    if (parseInt(this.query.province) == value.id) {
                        return value
                    }
                })
                this.cacheProvince = oldParamDistrict
            }
            if (this.query.district != '') {
                let oldParamDistrict = this.districts.filter((value) => {
                    if (parseInt(this.query.district) == value.id) {
                        return value
                    }
                })
                this.cacheDistrict = oldParamDistrict
            }
        },
        selectDistrictByProvince() {
            let provinceId = this.query.province
            this.districtsByProvince = []
            if (provinceId != undefined) {
                this.districts.map((value) => {
                    if (value.province_id == provinceId) {
                        this.districtsByProvince.push(value)
                    }
                })
                this.districtsByProvince.unshift({
                    name: 'Quận, huyện'
                })
            }

        },
        pullParamsUrl() {
            this.page = this.$route.query.page
            this.query.keyword_alias = this.$route.query.keyword_alias
            this.query.center = this.$route.query.center
            this.query.province = this.$route.query.province
            this.query.district = this.$route.query.district
            this.query.status = this.$route.query.status
            let status = this.query.status;

        },
        search: _.debounce(function () {
            this.query.center = this.$route.query.center
            this.query.province = this.$route.query.province
            this.query.district = this.$route.query.district
            this.pushParamsUrl()
            this.page = 1
            this.callApiGetList()
        }, 200),
        pushParamsUrl() {
            this.$router.push({
                name: 'office-index',
                query: {
                    keyword_alias: this.query.keyword_alias,
                    center: this.query.center,
                    province: this.query.province,
                    district: this.query.district,
                    status: this.query.status,
                    workplace: this.query.workplace
                }
            })
        },
        clickCallback(obj) {
            this.page = obj
            this.$router.push({path: '/office', query: {page: this.page}})
            this.callApiGetList()
        },
        callApiGetList() {
            this.$store.dispatch(GET_BRANCHES, {
                page: this.page,
                keyword_alias: this.query.keyword_alias,
                center: this.query.center,
                province: this.query.province,
                district: this.query.district,
                status: this.query.status,
                workplace: this.query.workplace
            }).then((res) => {
                this.branches = res.data.data.map(d => ({
                    ...d,
                    statusBool: d.status === 1
                }))
                this.last_page = res.data.last_page
            });
        },
        getWorkplaces() {
            this.$store.dispatch(GET_WORKPLACE, {}).then(data => {
                this.workplaces = data.data;
            });
        },
        getWorkplacesByBranch(workplace) {
            this.$store.dispatch(GET_WORKPLACE, {workplace: workplace}).then(data => {
                this.workplacesInBranch = data.data;
            });
        },
        handleQueryWorkplace($event) {
            this.query.workplace = $event
            this.pushParamsUrl()
            this.callApiGetList()
        },
        async getProvinces() {
            await this.$store.dispatch(GET_PROVINCES, []).then((res) => {
                if (!res.error) {
                    this.provinces = res.data
                    this.provinces.unshift({
                        name: 'Tỉnh thành'
                    })
                }
            }).catch((e) => {
                console.log(e, 'error')
            });
        },
        async getDistricts() {
            await this.$store.dispatch(GET_DISTRICTS, []).then((res) => {
                if (!res.error) {
                    this.districts = res.data
                    this.districts.unshift({
                        name: 'Quận, huyện'
                    })
                }
            }).catch((e) => {
                console.log(e, 'error')
            });
        },
        async getCenters() {
            await this.$store.dispatch(GET_CENTERS, {
                limit: 10000
            }).then((res) => {
                if (!res.error) {
                    this.centers = res.data.data
                    this.centers.unshift({
                        name: 'Trung tâm'
                    })
                }
            }).catch((e) => {
                console.log(e, 'error')
            });
        },

        handleQueryStatus($event) {
            this.query.status = $event.id

            if (this.$route.query.status != undefined) {
                this.query.province = this.$route.query.status
            }

            this.pushParamsUrl()
            this.callApiGetList()
        },
        getBranch(item) {
            this.getWorkplacesByBranch(item.workplace)
            this.$store.dispatch(GET_BRANCH_BY_ID, item.id).then((res) => {
                if (!res.error) {
                    this.branch = res.data
                    this.branch.workplace = this.branch.workplace_branch ? this.branch.workplace_branch.branch_id : '';
                    this.dialogEdit = true;
                }
            }).catch((e) => {
                console.log(e, 'error')
            });
        },
        onSubmitEdit()
        {
            this.$store.dispatch(UPDATE_BRANCH, this.branch).then((res) => {
                if (res.error) {
                    this.$bvToast.toast(res.message, {
                        title: 'Sửa tên văn phòng',
                        variant: 'danger',
                        solid: true
                    });
                } else {
                    this.$bvToast.toast(res.message, {
                        title: 'Sửa tên văn phòng',
                        variant: 'success',
                        solid: true
                    });
                }
                this.getList()
                this.dialogEdit = false;
            }).catch((e) => {
                if (e.data.data.message_validate_form) {
                    this.$refs.form.setErrors(e.data.data.message_validate_form);
                }
            });
        },
        handleUpdateStatusUserByBot(item)
        {
            let payload = {
                status: item.statusBool ? 1 : 0,
                id: item.id
            }

            this.$store.dispatch(ACTIVE_BRANCH, payload).then((res) => {
                if (item.status) {
                    this.$message.success('Kích hoạt thành công');
                } else {
                    this.$message.success('Ngừng kích hoạt thành công');
                }
                this.getList();
                this.getListBotByUserId();
            }).catch(e => {
                console.log(e, 'error')
            })
        }
    }
}
</script>
<style>
.fa-minus-circle:hover {
    color: red !important;

}
.input-group i {
    font-size : 0.9rem;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

